import React, { FC, ReactNode } from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import clsx from 'clsx';
import { AnimateHeight } from '@app/components/AnimateHeight';
import { useToggle } from 'react-use';
import s from './ExpandableDetails.module.scss';
import { formatUSD } from '@app/helpers/formatUSD';

interface Props {
  label: string;
  totalValue?: number;
  rows: {
    key: string;
    label: ReactNode;
    value: ReactNode;
  }[];
  isExpanded?: boolean;
}

const variants = {
  open: {
    opacity: 1,
    height: 'auto'
  },
  collapsed: { opacity: 0, height: 0 }
};

export const ExpandableDetails: FC<Props> = ({
  rows,
  label,
  totalValue,
  isExpanded = false
}) => {
  const [open, toggleOpen] = useToggle(isExpanded);

  return (
    <>
      <Box
        onClick={toggleOpen}
        className={clsx(s.row, s.rowMobile, {
          [s.open]: open
        })}
      >
        <Text fontSize={16} fontWeight={500} color="neutral.200">
          {label}
        </Text>
        <Text fontSize={16} fontWeight={500} color="neutral.200">
          {!!totalValue && formatUSD.format(totalValue)}
        </Text>
      </Box>
      <AnimateHeight
        variants={variants}
        ease="easeOut"
        duration={0.3}
        isVisible={open}
      >
        <VStack
          w="100%"
          gap={3}
          alignItems="flex-start"
          p={4}
          bg="neutral.1000"
          borderRadius={4}
        >
          {rows.map(row => {
            return (
              <HStack
                key={row.key}
                justifyContent="space-between"
                alignItems="center"
                w="100%"
              >
                {row.label}
                {row.value}
              </HStack>
            );
          })}
        </VStack>
      </AnimateHeight>
    </>
  );
};
